import { Col, Container, Row } from 'react-bootstrap';
import DonutChart from '../ApexCharts/DonutChart';
import GenericCard, { GenericCardVariant } from '../GenericCards';

export type ChartCardProps = {
  title: string;
  text: string | React.ReactNode;
  button: React.ReactNode;
  variant?: GenericCardVariant;
};

const dataDonutChart = {
  grid: {
    padding: {
      left: -6,
    },
  },
  legend: {
    show: false,
  },

  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        grid: {
          padding: {
            left: 0,
          },
        },
        legend: {
          show: false,
        },
        title: {},
      },
    },
  ],
  colors: ['#074CBC', '#07B4A0', '#92E3A9'],
  series: [423692, 246244, 31212],
  tooltip: {
    enabled: false,
  },
};

const ChartCard = ({
  title,
  text,
  button,
  variant = 'white',
}: ChartCardProps) => {
  return (
    <GenericCard variant={variant} className="ps-10 py-7 custom-chart-card">
      <Container>
        <Row className="align-items-center">
          <Col className="col-12 col-lg-3 p-lg-0 px-13">
            <DonutChart
              series={dataDonutChart.series}
              options={dataDonutChart}
            />
          </Col>
          <Col className="py-5">
            <h5 className="text-fs-base fw-normal pb-5 text-center text-lg-start ">
              {title}
            </h5>
            {text}
            <Col className="d-flex justify-content-end">{button}</Col>
          </Col>
        </Row>
      </Container>
    </GenericCard>
  );
};

export default ChartCard;
